UserSubscriptionModel.$inject = ["$modelFactory"];function _typeof(obj) {if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {_typeof = function _typeof(obj) {return typeof obj;};} else {_typeof = function _typeof(obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};}return _typeof(obj);}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (call && (_typeof(call) === "object" || typeof call === "function")) {return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}import { toFloat } from "../../shared/helpers/to-float";

export var userSubscriptionDefaults = {
  id: 0,
  created_at: null, // Date
  order_id: "",
  product_id: 0,
  amount: '', // "39.00",
  qty: 0,
  campaign_id: 0,
  cc_number: "",
  cc_type: "",
  cc_expires: "",
  cvv: "",
  upsell_product_id: null,
  upsell_campaign_id: null,
  canceled_at: null,
  is_external: false,
  transaction_receipt: "",
  customer: 0,
  plan: 0,
  main_order: null };


export function UserSubscriptionModel($modelFactory) {
  "ngInject";var

  UserSubscription = /*#__PURE__*/function (_$modelFactory) {_inherits(UserSubscription, _$modelFactory);function UserSubscription() {_classCallCheck(this, UserSubscription);return _possibleConstructorReturn(this, (UserSubscription.__proto__ || Object.getPrototypeOf(UserSubscription)).apply(this, arguments));}return UserSubscription;}($modelFactory('subscriptions', {
    defaults: userSubscriptionDefaults,
    map: {
      amount: toFloat } }));


  UserSubscription.List.Model = UserSubscription;

  return UserSubscription;
}